import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
import {MyMess} from '../../../App';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { CircularProgress, makeStyles, TextField } from '@material-ui/core';
import Axios from 'axios';
import {ReBranch} from '../../../server/WebServiceUrl'
import { GlobalSnackBarUtil } from '../../../component/GlobalSnackBar';

const useStyles = makeStyles((theme) => ({ 
    spinner: {
      margin: 10
    }
  }));
  

export default function LicenseAdminDialog(props) {
    const classes = useStyles();
  const { onClose, value: valueProp, licenseCode, open, ...other } = props; 
  const [isProcessing, setProcessing] = React.useState(false);
  let [reInitInfo, setReInitInfo] = useState({
      email:'',
      rebranchKey:''
  }) 
  

  const handleEntering = () => {
    // if (radioGroupRef.current != null) {
    //   radioGroupRef.current.focus();
    // }
  };

  const handleCancel = () => {    
    onClose();
  };

  const handleRebranch = () => {

    setProcessing(true);
    const rebranchAction = async function(){
        let result = {
            data:{}
        };

        try{
            result =  await Axios.post(ReBranch,{
                code:licenseCode,
                email:reInitInfo.email,
                rebranchKey:reInitInfo.rebranchKey
            })
        }catch(e){            
            if(e.response){
                result.data = e.response.data;
            }  
        }
        setProcessing(false);
        if(result.data.info){
            if(result.data.info.branchComplete){
                GlobalSnackBarUtil.open({
                    message:MyMess.curd.saveSuccess,
                    severity:'success'
                })
            }else{
                GlobalSnackBarUtil.open({
                    message:'Please contact technical team to check',
                    severity:'error'
                })
            }
        }else{
            GlobalSnackBarUtil.open({
                message:result.data,
                severity:'error'
            })
        }   
    }

    rebranchAction()
  };
  
  const changeHandler = e => {
    setReInitInfo({...reInitInfo, [e.target.name]: e.target.value})        
 }


  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      onEntering={handleEntering}
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
    >
      <DialogTitle id="confirmation-dialog-title"></DialogTitle>
      {isProcessing &&  <CircularProgress className={classes.spinner} size={36} thickness={4} />}
      <DialogContent dividers>
      <form>        
        <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label={MyMess.general.emailAddress}
            name="email"
            autoComplete="email"
            autoFocus
            value={reInitInfo.email}      
            onChange={changeHandler}      
            //disabled={isSubmitting}
        />

        <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="rebranchKey"
            label={MyMess.kopaproLicense.rebranchKey}
            name="rebranchKey"                        
            value={reInitInfo.rebranchKey}    
            onChange={changeHandler}              
            //disabled={isSubmitting}
        />
        </form>

        <Button onClick={handleRebranch} disabled={isProcessing} >
            {MyMess.kopaproLicense.rebranch}
        </Button>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} disabled={isProcessing} >
            {MyMess.general.back}
        </Button>
        
      </DialogActions>
    </Dialog>
  );
}

LicenseAdminDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,    
    licenseCode: PropTypes.string.isRequired,
    licenseStatus: PropTypes.string.isRequired
};
